import Rewards from './RewardsContainer';

export default Rewards;
